import {Injectable} from '@angular/core';
import {PropertyMappingModel} from './models/property-mapping.model';
import {PropertyLineModel} from './models/property-line.model';
import {isValue, LanguageQuery, PropertyQuery, stringCompare} from 'common-shared';

@Injectable({
  providedIn: 'root'
})
export class PropertyMappingService {

  constructor() {
  }

  static addNew(propertyId: string, languageId: string, mandatoryClv: string, orderOriginId: string, activityId: string, sourceId: string, sourceCode: string, isNew = true): PropertyMappingModel {
    return Object.assign(new PropertyMappingModel(), {
      PropertyId: propertyId,
      LanguageId: languageId,
      MandatoryClv: mandatoryClv,
      OrderOriginClv: orderOriginId,
      ActivityId: activityId,
      SourceId: sourceId,
      SourceCode: sourceCode,
      $isNew: isNew
    });
  }

  static addNewLine(propertyId: string, languageId: string, sourceId: string, sourceCode: string): PropertyLineModel {
    return Object.assign(new PropertyLineModel(), {
      PropertyId: propertyId,
      LanguageId: languageId,
      SourceId: sourceId,
      SourceCode: sourceCode
    });
  }

  static lineHasChanges(to: PropertyLineModel, from: PropertyLineModel) {
    if (to.NumericValue !== from.NumericValue) {
      return true;
    }
    if (to.Value !== from.Value) {
      return true;
    }
    if (to.ValueClv !== from.ValueClv) {
      return true;
    }
    if (to.DateTimeValue !== from.DateTimeValue) {
      return true;
    }
    return false;

  }

  static mappingHasChanges = function (to: PropertyMappingModel, from: PropertyMappingModel) {
    if (to.Alias !== from.Alias) {
      return true;
    }
    if (to.MandatoryClv !== from.MandatoryClv) {
      return true;
    }
    if (to.Expression.Formula !== from.Expression.Formula) {
      return true;
    }
    if (to.Constraints.Formula !== from.Constraints.Formula) {
      return true;
    }

    return false;
  };

  static lineHasValue(property: PropertyQuery, line: PropertyLineModel) {
    if (property === undefined) {
      return false;
    }

    if (property.TypeClv === 'a8217081-8cda-40a1-b6c0-de33462eaee3') {
      return isValue(line.NumericValue);
    }
    if (property.TypeClv === '87a7ce66-5960-4e1c-b1c2-50c717bf6b80') {
      return isValue(line.ValueClv);
    }
    return isValue(line.Value);
  }

  static getMappingPerLanguage(propertyMappings: PropertyMappingModel[], propertyId: string, languages: LanguageQuery[]) {
    return (propertyMappings || [])
      .filter(function (mapping) {
        return mapping.PropertyId === propertyId && mapping.LanguageId !== null;
      }).map(function (mapping) {
        mapping.$Language = ((languages || []).find(function (l) {
          return l.Id === mapping.LanguageId;
        }) || new LanguageQuery()).DisplayName;
        return mapping;
      }).sort((a, b) => stringCompare(a, b, obj => obj.$Language));
  }
}
